<template>
    <div class="row d-flex justify-content-center mt-10 mb-70 order-timeline">
        <div class="col-md-12 mt-10">
            <div class="main-card mb-3 card rounded-4">
                <div class="card-header py-2 rounded-top-4">Order Timeline</div>
                <div class="card-body">
                    <div class="scroll-area">
                        <div class="vertical-timeline vertical-timeline--animate vertical-timeline--one-column">
                            <div class="activity">
                                <template v-for="(history, index) in order.order_histories" >
                                    <div v-if="visibleActivity(history)" class="activity-item d-flex">
                                        <div class="activite-label small text-black pb-3 pe-3 ">
                                            {{dataTimeFormat(history.created_at, 'DD/MM/YYYY')}} <br>
                                            {{ dataTimeFormat(history.created_at, 'hh:mm A') }} <br/>
                                            <small>By {{history?.user?.first_name}}</small>
                                        </div>
                                        <i class='bi bi-circle-fill activity-badge text-theme align-self-start'></i>
                                        <div class="activity-content pb-3 ps-3">
                                            <strong class="timeline-title text-capitalize">{{ (history.action_type).replace(/_/g, ' ') }}</strong>
                                            <!-- Display order logs -->
                                            <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.logs?.length > 0" class="col-md-12">
                                                <p
                                                    v-for="(orderLog, index) in JSON.parse(history.data)?.logs"
                                                    :key="index"
                                                    class="mb-1 small"
                                                    v-html="orderLog.value"
                                                >
                                                </p>
                                            </div>
                                            <div v-else-if="history.comment" class="col-md-12">
                                                <p class="mb-1 small" v-html="history.comment"></p>
                                            </div>

                                            <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.order_images"
                                                class="col-md-12 d-flex flex-row flex-wrap"
                                            >
                                                <div class="image-preview-row d-flex flex-row flex-wrap">
                                                    <a
                                                        v-for="(historyImg, index) in JSON.parse(history.data)?.order_images"
                                                        :key="historyImg.id"
                                                        :href="$s3RootUrl + '/order/' + historyImg.image"
                                                        :class="{ 'order-img-slides': ['image', 'video', 'pdf'].includes(historyImg.file_type) }"
                                                    >
                                                        <img
                                                            :src="prepareImageSource(historyImg)"
                                                            class="img-thumbnail me-2 mb-2 cursor-pointer"
                                                            style="max-height: 150px; max-width: 150px;"
                                                        />
                                                    </a>
                                                </div>
                                            </div>

                                            <!-- Check if deleted items exists in the history data -->
                                            <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.deleted_items" class="col-md-12 small">
                                                <h6 class="fw-bold fs-6 text-danger">Service Deleted</h6>
                                                <p v-for="(item, index) in JSON.parse(history.data)?.deleted_items" :key="index" class="mb-1">
                                                    Service <span class="fw-bold">{{ item.service_name }}</span> is deleted from the order.
                                                </p>
                                            </div>

                                            <!-- Check if new items exists in the history data -->
                                            <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.new_items" class="col-md-12 small">
                                                <h6 class="fw-bold fs-6 text-success pt-2">Service Added</h6>
                                                <p v-for="(item, index) in JSON.parse(history.data)?.new_items" :key="index" class="mb-1">
                                                    Service <span class="fw-bold">{{ item.service_name }}</span> is added to the order.
                                                </p>
                                            </div>

                                            <!-- Check if updated_items exists in the history data -->
                                            <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.updated_items" class="col-md-12 small">
                                                <h6 class="fw-bold fs-6 text-warning pt-2">Service Updated</h6>
                                                <p v-for="(item, index) in JSON.parse(history.data)?.updated_items" :key="index" class="mb-1">
                                                    Service <span class="fw-bold">{{ item.service_name }}</span> is updated in the order.
                                                </p>
                                            </div>

                                            <!-- Check if total_before_update and total_after_update exists in the history data -->
                                            <!-- <div v-if="JSON.parse(history.data) && JSON.parse(history.data)?.total_before_update && JSON.parse(history.data)?.total_after_update && (JSON.parse(history.data)?.total_before_update != JSON.parse(history.data)?.total_after_update)" class="col-md-12 small">
                                                <p class="mb-1">Price updated from : <span class="fw-bold">{{ currencySymbol + '' + JSON.parse(history.data)?.total_before_update }}</span> to <span class="fw-bold">{{ currencySymbol + '' + JSON.parse(history.data)?.total_after_update }}</span>.</p>
                                            </div> -->
                                        </div>
                                    </div><!-- End activity item-->
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { appMixin } from "../mixin/appMixin";
export default {
    name: "OrderActivity",
    props: {
        order: {
            type: Object,
            default: () => ({})
        }
    },
    mixins: [appMixin],
    methods: {
        visibleActivity(item) {
            let logs = item.data ? JSON.parse(item.data) : {};
            // First check if comment or logs available then show
            if(item.comment || logs?.logs) {
                console.log("Visible");
                return true;
            }
            console.log("Hidden");
            return false;
        },
        prepareImageSource(imgObj) {
            if (imgObj.file_type === 'image') {
                if (imgObj.uploaded) {
                    return imgObj.file_name;
                }
                else if (typeof imgObj.file_name !== 'undefined') {
                    return this.$s3RootUrl + "/order/" + imgObj.file_name;
                }
                else {
                    return this.$s3RootUrl + "/order/" + imgObj.image;
                }
            }
            else if(imgObj.file_type === 'video') {
                return this.$baseUrl + "/images/svg/file-video.svg";
            }
            else if(imgObj.file_type === 'zip') {
                return this.$baseUrl + "/images/svg/file-archive.svg";
            }
            else if(imgObj.file_type === 'pdf') {
                return this.$baseUrl + "/images/svg/file-pdf.svg";
            }
            else {
                return this.$baseUrl + "/images/svg/file-text.svg";
            }
        }
    }
}
</script>
